import { Injectable } from '@angular/core';
import { map, mergeMap } from 'rxjs';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as paymentTableActions from '@payments-to-you/actions/payments-to-you-table';
import { PaymentsToYouHttpService } from '@feature/payments-to-you/services/payments-to-you-http.service';

@Injectable()
export class PaymentsTableEffects {

  constructor(
    private readonly actions$: Actions,
      private readonly paymentsToYouHttpService: PaymentsToYouHttpService
  ) { }

  loadInternalEffect = createEffect(() => this.actions$.pipe(
      ofType(paymentTableActions.loadInternal),
      mergeMap(({ context, widget }) => {
        return this.paymentsToYouHttpService.getInternalPaymentsTable(context, widget.id).pipe(
          map(paymentTable => paymentTableActions.loadComplete({ payload: paymentTable, widget }))
      );
    })
  ));

  loadExternalEffect = createEffect(() => this.actions$.pipe(
    ofType(paymentTableActions.loadExternal),
    mergeMap(({ accountRef, widget }) => {
      return this.paymentsToYouHttpService.getExternalPaymentsTable(widget.id, accountRef).pipe(
        map(paymentTable => paymentTableActions.loadComplete({ payload: paymentTable, widget }))
      );
    })
  ));
}
